angular.module("dx.webapp.student").
factory("DxStudent", function studentFactory(
	DxAnswer,
	FinalGrade
) {
	"use strict";

	function Student(data) {
		angular.extend(this, {
			// Student properties

			id: 0,
			name: "", // Deprecated
			firstName: "",
			lastName: "",
			code: "",
			email: "",
			anonymousId: 0,
			state: 0,
			answers: [],
			finalGrade: null,
			flags: 0,
			spellCheckAllowed: false,
			textToSpeechAllowed: false,
			UsbAudioAllowed: false,
			ImmersiveReaderAllowed: false,
			redactedPii: false,

			// Public functions

			isGraded: function isGraded() {
				if (this.isFinalGradeSet()) {
					return true;
				}

				return false;
			},
			isPartiallyGraded: function isPartiallyGraded() {
				for (var j = 0; j < this.answers.length; j++) {
					if (this.answers[j].isGraded()) {
						return true;
					}
				}
				return false;
			},
			isAnswerPartiallyGraded: function isAnswerPartiallyGraded(a) {
				return a.isPartial();
			},
			isFinalGradeSet: function isFinalGradeSet() {
				var grade = this.finalGrade ? this.finalGrade.grade : null;
				return grade && typeof grade === "string";
			},
			isFlagSet: function isFlagSet(flag) {
				return (this.flags & flag) === flag;
			},
			getNumGradedAnswers: function getNumGradedAnswers(includeFinalGrade) {
				var numberOfGradedAnswers = 0;
				for (var j = 0; j < this.answers.length; j++) {
					if (this.answers[j].isGraded()) {
						numberOfGradedAnswers++;
					}
				}

				if (includeFinalGrade && this.isFinalGradeSet()) {
					numberOfGradedAnswers++;
				}

				return numberOfGradedAnswers;
			},
			getName: function getName(firstNameOnly, appendS) {
				var useFirstnameOnly = firstNameOnly;
				if (firstNameOnly === null) {
					useFirstnameOnly = true;
				}

				var name = this.name;

				if (typeof name !== "string" || name.length === 0) {
					return "";
				}

				if (useFirstnameOnly) {
					name = name.trim().split(" ")[0];
				}

				if (appendS) {
					if (name.charAt(name.length - 1) !== "s") {
						name += "s";
					}
				}

				return name;
			},
			getTotalScore: function getTotalScore() {
				return this.answers.reduce(function addTotal(total, answer) {
					return total + parseFloat(answer.grade.score) || total;
				}, 0);
			},
		});

		if (data) {
			if (data.answers) {
				for (var i = 0; i < data.answers.length; i++) {
					data.answers[i] = new DxAnswer(data.answers[i]);
				}
			} else {
				data.answers = [];
			}

			data.finalGrade = new FinalGrade(data.finalGrade);
			delete data.note;

			angular.extend(this, data);
		}
	}

	return Student;
});
